import {Injectable} from "@angular/core";
import moment from "moment";
import {TokenData} from "../types/token-data.interface";

@Injectable({
  providedIn: 'root'
})
export class TokenStore {
  public static readonly ACCESS_TOKEN_KEY: string = 'token';
  public static readonly REFRESH_TOKEN_KEY: string = 'refresh_token';

  save(
    token: string,
    refresh: string
  ): void {

    var jwt = localStorage.getItem('jwt');

    if (jwt !== null) {
      var objectJWT = JSON.parse(jwt)
      objectJWT['token'] = token
      objectJWT['refresh_token'] = refresh
      localStorage.setItem('jwt', JSON.stringify(objectJWT));
    }
  }

  clear(): void {
    localStorage.removeItem(TokenStore.ACCESS_TOKEN_KEY);
    localStorage.removeItem(TokenStore.REFRESH_TOKEN_KEY);
  }

  get(): string {
    var jwt = localStorage.getItem('jwt');

    if (jwt !== null) {

      var objectJwt = JSON.parse(jwt)

      return objectJwt[TokenStore.ACCESS_TOKEN_KEY]
    }

    return '';
  }

  getRefresh() {
    var jwt = localStorage.getItem('jwt');

    if (jwt !== null) {

      var objectJwt = JSON.parse(jwt)

      return objectJwt[TokenStore.REFRESH_TOKEN_KEY]
    }

    return '';
  }

  getData(): TokenData | null {
    const token = this.get();

    if (token !== null) {


      const data = JSON.parse(atob(token.split('.')[1]));

      // verify token
      if (!this.isTokenValid(token, data)) {
        throw new Error('Invalid Token');
      }

      return data;
    }

    return null
  }

  isTokenValid(
    token: string,
    data: TokenData
  ): boolean {
    // token expired
    const currentTimestamp = moment().valueOf();
    if (data.exp > currentTimestamp) {
      // expired token
      return false;
    }

    return true;
  }
}
